export const getVariantDetails = (id: number, variants: any, allOptions: any) => {
  if (variants?.[0]?.option1 === 'Default Title' || variants?.length === 1) {
    return variants[0];
  }
  const selectedVariant = variants?.find((product: any) => {
    if (product?.option1 && product?.option2 && product?.option3) {
      return (
        product?.option1 === allOptions?.[id]?.option1 &&
        product?.option2 === allOptions?.[id]?.option2 &&
        product?.option3 === allOptions?.[id]?.option3
      );
    }
    if (product?.option1 && product?.option2) {
      return product?.option1 === allOptions?.[id]?.option1 && product?.option2 === allOptions?.[id]?.option2;
    }
    if (product?.option1 === allOptions?.[id]?.option1) {
      return product?.option1 === allOptions?.[id]?.option1;
    }
    return null;
  });
  return selectedVariant;
};

export const getProductPrice = (product: any, allOptions?: any): number => {
  if (product?.variants?.length) {
    const variant = getVariantDetails(product.id, product.variants, allOptions);
    if (variant?.price != null) {
      return Number(variant.price);
    }
    return Math.min(...product.variants.map((v: any) => Number(v.price)));
  }
  return Number(product.price || 0);
};

export const getOrderDetails = (selectedProductsForOrder: any, allOptions: any, quantities: any) => {
  return selectedProductsForOrder.map((product: any) => {
    const variant = getVariantDetails(product.id, product.variants, allOptions);
    const variantDetailObject: any = {};
    if (
      product?.variants?.[0] &&
      product?.variants?.[0]?.option1 !== 'Default Title' &&
      Object.keys(allOptions).length > 0
    ) {
      if (product?.options?.length > 0 && allOptions[product.id]) {
        product.options.forEach((option: any, index: number) => {
          variantDetailObject[option.name] = allOptions[product.id][`option${index + 1}`];
        });
      }
    }
    const quantity = quantities[variant?.variantId || product?.id];
    return {
      variantId: variant?.variantId || product?.id,
      productId: product?.id,
      productDetails: {
        productImage: product?.image,
        productName: product?.name,
        productPrice: variant?.price,
        variantDetail: variantDetailObject,
      },
      quantity,
    };
  });
};

export const checkIfDisabled = (selectedProducts: any, allOptions: any) => {
  const disabledArray = selectedProducts.map((product: any) => {
    if (product.options?.[0]?.options?.[0] === 'Default Title') {
      return false;
    }
    if (product?.options?.length === 3) {
      return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2 || !allOptions[product.id]?.option3;
    }
    if (product?.options?.length === 2) {
      return !allOptions[product.id]?.option1 || !allOptions[product.id]?.option2;
    }
    if (product?.options?.length === 1) {
      return !allOptions[product.id]?.option1;
    }
    return false;
  });
  return !disabledArray.every((ele: any) => ele === false);
};
